import { useFlags } from 'launchdarkly-react-client-sdk';
import { useParams } from 'react-router-dom';

import LoadingSpinner from '@/components/LoadingSpinner';
import { ContentLayout } from '@/pages/overview/common/ContentLayout';
import { RedlineClusteringSidebar } from '@/pages/overview/redline/clustering/RedlineClusteringSidebar';
import { RedlineClusterList } from '@/pages/overview/redline/clustering/RedlineClusterList';
import { useRedline } from '@/pages/overview/redline/useRedline';

const RedlineClustering = () => {
  const { redlineName } = useParams();
  const flags = useFlags();
  const { redline } = useRedline(redlineName);
  if (!redline)
    return (
      <div className="flex size-full flex-col items-center justify-center gap-4 rounded-[12px] bg-marveri-background">
        <h1 className="text-[34px] font-bold text-marveri-white">Generating Clusters...</h1>
        <LoadingSpinner size={20} />
      </div>
    );
  if (flags.redlineClusterListUi) {
    return <RedlineClusterList />;
  }
  return (
    <ContentLayout
      content={<RedlineClusterList />}
      sidebar={<RedlineClusteringSidebar redline={redline} />}
    />
  );
};

export default RedlineClustering;
